/* eslint-disable max-lines */
import $ from 'jquery';
import 'normalize.css/normalize.css';
import '@pst/assets/index.less';
import { imgViewer, mountModal, openLinkByAnchor } from '@pst/utils';
// import { appConfig } from '@pst/app-config';
// import Swiper from 'swiper';
// import { Autoplay, Mousewheel, Navigation, Pagination } from 'swiper/modules';
import { AudioController } from './music';
import { type ClickType, reportEvents } from './reportEvents';
// import Player from 'xgplayer';
// import 'xgplayer/dist/index.min.css';

import type { SwiperOptions } from 'swiper/types';
import { mountPage } from './pages';
import { newsModule } from './services';
import { getNow, websiteTiming } from './config/timing';

// import zhSignUp from './assets/img/sign-up-title-zh.png';
const isPC = window.entryType === 'pc';

export const modalInstance = mountModal();
export function setImgs(_isMobile?: boolean) {}

export const run = (Swiper: any, { Autoplay, Mousewheel, Navigation, Pagination }: any, player?: any) => {
  // TODO mac 触摸板控制
  const swiperConfig = isPC
    ? {
        modules: [Mousewheel],
        mousewheel: {
          sensitivity: 1, // 调整鼠标滚轮的灵敏度
          releaseOnEdges: true, // 当滚动到边缘时释放控制
        },
        // 设置最小滑动距离
        threshold: 25,
        // 降低滑动灵敏度
        touchRatio: 0.5,
        // 禁用短滑动触发页面切换
        shortSwipes: true,
        // 启用长滑动触发页面切换
        longSwipes: false,
        // 长滑动的最小比例
        longSwipesRatio: 1,
        // 禁用自由滑动模式
        freeMode: false,
        // 禁用鼠标模拟触摸事件
        simulateTouch: true,
        allowTouchMove: true,
        // 设置触摸角度（防止斜向滑动）
        touchAngle: 45,
      }
    : {};

  const url = new URL(window.location.href);
  const initialPageIndex = url.searchParams.get('page_index')
    ? Number(url.searchParams.get('page_index'))
    : undefined;

  const MenuType = {
    home: 'home',
    news: 'news',
    features: 'features',
    media: 'media',
  };

  const menuIndex = [MenuType.home, MenuType.news, MenuType.features, MenuType.media];

  let init = true;
  /** 最后一个 slide 不会触发 slideChange和更改 activeIndex 等，监控当前吸附的 index 来确定是不是最后一个 */
  let pageSwiperSnapIndex = initialPageIndex || 0;
  // 全屏滚动
  const pageSwiper = new Swiper('.page-swiper', {
    direction: 'vertical',
    slidesPerView: 'auto',
    roundLengths: true,
    initialSlide: initialPageIndex,
    ...swiperConfig,
    on: {
      slideChange(swiper) {
        if (init) {
          return;
        }
        const currentURL = new URL(window.location.href);
        currentURL.searchParams.set('page_index', String(swiper.realIndex));
        updateMenu(swiper.realIndex);
        history.pushState({}, '', currentURL.toString());
        if (swiper.activeIndex > 0) {
          player?.pause();
        } else {
          player?.play();
        }
      },
      snapIndexChange(swiper) {
        pageSwiperSnapIndex = swiper.snapIndex;
      },
    },
  });

  function updateMenu(index: number, noSlice?: boolean) {
    const menus = $('.menus');
    if (!menus.length) {
      return;
    }
    $('.menu-item').removeClass('active');
    const match = menuIndex[index];
    const $nextMenu = $(`.menu-item[data-type="${match}"]`);
    $nextMenu.addClass('active').siblings().removeClass('active');

    const activeTop = $nextMenu.position().top;
    const parentHeight = $nextMenu.parent().height() || 0;

    $('.menus-active-bar').css({
      top: `${(activeTop / parentHeight) * 100}%`,
    });

    if (!noSlice) {
      pageSwiper.slideTo(index);
    }
  }
  init = false;

  $('.menu-item').on('click', (e) => {
    const type = (e.currentTarget as HTMLDivElement).dataset.type;
    const index = menuIndex.findIndex((i) => i === type);
    updateMenu(index);
    // try {
    //   if (featuresSwiper) {
    //     if (index <= 2) {
    //       switchFeaturesSwiper('start');
    //     } else {
    //       switchFeaturesSwiper('end');
    //     }
    //   }
    // } catch {}
  });

  $('.gallery-btn').on('click', function (e) {
    const type = e.currentTarget.getAttribute('data-type');
    const $this = $(this);
    $this.addClass('is-active').siblings().removeClass('is-active');

    if (type === 'img') {
      $('.gallery-for-img').show();
      $('.gallery-for-video').hide();
      $('.gallery-img').show();
      $('.gallery-video').hide();
      const video = document.querySelector<HTMLVideoElement>('.gallery-video');
      if (video) {
        video.pause();
      }
      if (imgSwiper) {
        imgSwiper.autoplay.start();
      }
    } else {
      $('.gallery-for-img').hide();
      $('.gallery-for-video').show();
      $('.gallery-img').hide();
      $('.gallery-video').show();
      if (imgSwiper) {
        imgSwiper.autoplay.stop();
      }
    }
  });

  $('.gallery-img').on('click', (e) => {
    const url = (e.currentTarget as HTMLImageElement).src;
    if (url) {
      imgViewer(url);
    }
  });

  function setCurrentGalleryImg(index: number | string) {
    const $img = document.querySelector<HTMLImageElement>('.gallery-img');
    const $source = document.querySelector<HTMLImageElement>(
      `.gallery-for-img .gallery-preview[data-index="${index}"]`,
    );

    $('.gallery-for-img .gallery-box').removeClass('gallery-active');

    if ($img && $source) {
      $img.src = $source.src;
      $img.style.opacity = '1';
      $source.parentElement?.classList.add('gallery-active');
    }
  }
  setCurrentGalleryImg(0);

  $('.gallery-for-img .gallery-preview').on('click', (e) => {
    const index = e.currentTarget.getAttribute('data-index');
    if (index) {
      setCurrentGalleryImg(index);
    }
  });

  const imgSwiper = new Swiper('.gallery-for-img .swiper', {
    slidesPerView: isPC ? 3 : 2,
    spaceBetween: 20,
    roundLengths: true,
    modules: isPC ? [Navigation, Autoplay] : [Navigation, Autoplay, Pagination],
    navigation: {
      nextEl: '.gallery-for-img .gallery-btn-right',
      prevEl: '.gallery-for-img .gallery-btn-left',
    },
    loop: true,
    pagination: isPC
      ? undefined
      : {
          el: '.gallery-for-img .swiper-pagination',
        },
    autoplay: true,
    on: {
      slideChange(swiper) {
        setCurrentGalleryImg(swiper.realIndex);
      },
    },
  });

  const featuresSwiperConfig: SwiperOptions = isPC
    ? {
        modules: [Pagination, Navigation],
        pagination: {
          el: '.features-swiper .swiper-pagination',
          clickable: true,
        },
        loop: true,
        navigation: {
          nextEl: '.features-arrow-right',
          prevEl: '.features-arrow-left',
        },
        nested: true, // 建议开启，有助于处理一些嵌套场景
        on: {
          slideChange(swiper) {
            console.log(swiper.realIndex);
          },
          // 当用户开始触摸内部 Swiper 时
          touchStart: () => {
            // 立即禁止外部 Swiper 滑动，防止内外同时响应
            pageSwiper.allowTouchMove = false;
          },

          // 当用户在内部 Swiper 上滑动时
          touchMove: (swiper) => {
            const { isBeginning, isEnd, touches } = swiper;
            // touches.diff 是垂直方向的滑动距离，向上滑动为负，向下滑动为正

            // 如果内部 Swiper 在最顶部，且用户向下滑动（试图向上翻页）
            if (isBeginning && touches.diff > 0) {
              pageSwiper.allowTouchMove = true; // 允许外部 Swiper 滑动
            }
            // 如果内部 Swiper 在最底部，且用户向上滑动（试图向下翻页）
            else if (isEnd && touches.diff < 0) {
              pageSwiper.allowTouchMove = true; // 允许外部 Swiper 滑动
            }
            // 其他情况（在内部滑动），保持外部 Swiper 禁止状态
            else {
              pageSwiper.allowTouchMove = false;
            }
          },

          // 当用户释放触摸时
          touchEnd: () => {
            // 无论如何，触摸结束后都恢复外部 Swiper 的滑动能力
            pageSwiper.allowTouchMove = true;
          },
        },
      }
    : {
        modules: [Pagination],
        nested: true,
        loop: true,
        pagination: {
          el: '.features-swiper .swiper-pagination',
          clickable: true,
        },
      };

  new Swiper('.features-swiper', featuresSwiperConfig);

  // /** 非正常模式下更改 pageSwiper，设置featuresSwiper状态 */
  // function switchFeaturesSwiper(type: 'start' | 'end') {
  //   if (type === 'start') {
  //     featuresSwiper.slideTo(0);
  //   } else {
  //     featuresSwiper.slideTo(featuresSwiper.slides.length - 1);
  //   }
  // }

  if (initialPageIndex) {
    try {
      setTimeout(() => {
        updateMenu(initialPageIndex, true);
      }, 0);
    } catch {}
  }

  // function createVideo(parentNode?: HTMLDivElement) {
  //   const el = document.createElement('div');
  //   el.id = 'pv-video';
  //   let player: Player | undefined = undefined;

  //   return {
  //     el,
  //     close() {
  //       if (player) {
  //         player.destroy();
  //       }
  //       if (parentNode) {
  //         parentNode.removeChild(el);
  //       }
  //     },
  //     play() {
  //       if (parentNode) {
  //         parentNode.appendChild(el);
  //         player = new Player({
  //           id: 'pv-video',
  //           height: '100%',
  //           width: '100%',
  //           definition: {
  //             defaultDefinition: '720p',
  //             list: [
  //               {
  //                 definition: '720p', // 清晰度
  //                 url: 'https://lf16-pstcdn-alisg.bytedgame.com/obj/lf-game-alisg/gdl_app_613238/web/pst_pv_720p.mp4',
  //                 text: {
  //                   zh: '720p',
  //                   en: '720p',
  //                 },
  //               },
  //               {
  //                 definition: '2K', // 清晰度
  //                 url: 'https://lf16-pstcdn-alisg.bytedgame.com/obj/lf-game-alisg/gdl_app_613238/web/pst_pv.mp4', // 对应播放地址
  //                 text: {
  //                   zh: '2K',
  //                   en: '2K',
  //                 },
  //               },
  //             ],
  //           },
  //         });
  //         setTimeout(() => {
  //           player?.play?.();
  //         }, 0);
  //       }
  //     },
  //   };
  // }
  // const playerParent = (document.querySelector('#pv-video')?.parentNode as HTMLDivElement) || undefined;
  // const videoController = createVideo(playerParent);

  /** 一些 click out side 的事件点击在背景视频时， 阻止背景视频关闭音乐 */
  let lockBgMusicMute = false;

  reportEvents.sendWhileLaunch();

  $(document.body).on('click', '*[data-event]', (e) => {
    const el = e.currentTarget as HTMLElement;
    if (el.matches('[data-event="WishlistPC"], [data-event="PCDownload"]')) {
      const wishlist = el.closest('.wishlist');
      if (wishlist?.classList.contains('is-launched')) {
        e.preventDefault();
        return;
      }
    }

    const event = el.getAttribute('data-event');
    reportEvents.sendBtnClick(event as ClickType);
    if (el.tagName.toLocaleUpperCase() === 'A') {
      e.preventDefault();
      setTimeout(() => {
        openLinkByAnchor((el as HTMLAnchorElement).href);
      }, 100);
    }
    // e.preventDefault();
  });

  const audio = new AudioController({
    onBgmPlay() {
      $('.header-music').addClass('is-on');
    },
    onBgmStop() {
      $('.header-music').removeClass('is-on');
    },
  });

  $('.header-music').on('click', () => {
    audio.switchBgm();
  });

  $('.video-background').on('click', (e) => {
    if (lockBgMusicMute) {
      lockBgMusicMute = false;
      return;
    }
    modalInstance.showModal(e.currentTarget.dataset.modalTarget || '');
    // reportEvents.sendBtnClick(ClickType.HomePV);
    setTimeout(() => {
      audio.muteBgm();
      // (document.querySelector('.pv-video') as HTMLVideoElement).play();
      // videoController.play();
    }, 50);
  });

  modalInstance.addModalCloseEvent('pv', () => {
    const $pvVideo = document.querySelector('.pv-modal video') as HTMLVideoElement;
    $pvVideo?.pause();
  });

  $('.media-btn').on('mouseenter', () => {
    audio.instance.btnHover.play();
  });

  $('.btn-submit').on('mouseenter', () => {
    audio.instance.btnHover.play();
  });

  $('.media-btn').on('click', () => {
    audio.instance.btnClick.play();
  });

  $('.btn-submit').on('click', () => {
    audio.instance.signUpClick.play();
  });

  const video = document.querySelector('.video-background') as HTMLVideoElement;
  if (video?.tagName === 'VIDEO' && video?.paused) {
    video.play();
  }

  $('.to-register').on('click', () => {
    // 最后一个 tab 不触发，否则会影响 scroll
    if (pageSwiperSnapIndex === 4) {
      return;
    }
    // switchFeaturesSwiper('end');
    const matchIndex = menuIndex.findIndex((i) => i === MenuType.media);
    updateMenu(matchIndex);
    pageSwiper.slideTo(4);
  });

  // 打印全部的点击事件
  document.body.addEventListener('click', (e) => {
    let currentNode = e.target as HTMLElement;
    while (currentNode) {
      if (currentNode.tagName === 'A') {
        console.log((currentNode as HTMLAnchorElement).href);
        break;
      }
      if (currentNode === document.body) {
        break;
      }
      currentNode = currentNode.parentNode as HTMLElement;
    }
  });

  mountPage();

  const getVideoData = async () => {
    const res = await newsModule.instance.getBatchResource({
      website: isPC ? 152 : 153,
      channels: [
        {
          channel: 4,
          resource_type: 3,
        },
      ],
    });
    if (res?.[4].page_videos?.length) {
      const list = res[4].page_videos;
      renderVideo(list);
      bindVideoEvent();
    }
  };

  const renderVideo = (list: any[]) => {
    const html = list
      .map((item, index) => {
        return `
        <div class="swiper-slide">
          <div class="gallery-box">
            <img
              class="gallery-preview"
              data-index="${index}"
              src="${item.image}"
              data-src="${item.url || item.origin_url}"
              loading="lazy"
              alt=""
            />
            <div class="gallery-cover"></div>
            <div class="gallery-play"></div>
          </div>
        </div>
    `;
      })
      .join('');
    $('.gallery-video-swiper .swiper-wrapper').html(html);
  };
  const bindVideoEvent = () => {
    function setCurrentGalleryVideo(index: number | string) {
      const $video = document.querySelector<HTMLImageElement>('.gallery-video');
      const $source = document.querySelector<HTMLImageElement>(
        `.gallery-for-video .gallery-preview[data-index="${index}"]`,
      );
      $('.gallery-for-video .gallery-box').removeClass('gallery-active');
      if ($video && $source) {
        $video.src = $source.getAttribute('data-src') || '';
        $video.style.opacity = '1';
        $source.parentElement?.classList.add('gallery-active');
      }
    }

    setCurrentGalleryVideo(0);

    $('.gallery-for-video .gallery-preview').on('click', (e) => {
      const index = e.currentTarget.getAttribute('data-index');
      if (index) {
        setCurrentGalleryVideo(index);
      }
    });

    new Swiper('.gallery-for-video .swiper', {
      slidesPerView: isPC ? 3 : 2,
      spaceBetween: 20,
      roundLengths: true,
      modules: isPC ? [Navigation] : [Navigation, Pagination],
      loop: true,
      pagination: isPC
        ? undefined
        : {
            el: '.gallery-for-video .swiper-pagination',
          },
      navigation: {
        nextEl: '.gallery-for-video .gallery-btn-right',
        prevEl: '.gallery-for-video .gallery-btn-left',
      },
      on: {
        slideChange(swiper) {
          setCurrentGalleryVideo(swiper.realIndex);
        },
      },
    });
  };
  getVideoData();
};

export type TimePhase = 'before_prepurchase' | 'prepurchase' | 'launched';

export const getCurrentPhase = (): TimePhase => {
  const now = getNow();
  const { prePurchaseStart, gameLaunch } = websiteTiming;
  if (now < prePurchaseStart) {
    return 'before_prepurchase';
  }
  if (now < gameLaunch) {
    return 'prepurchase';
  }
  return 'launched';
};

export const updateWishlistArea = (isMobile?: string) => {
  const phase = getCurrentPhase();
  const prePurchaseUrl = isMobile
    ? 'https://www.migufun.com/middleh5/gamedetail/401157954?appChannel=40257763344'
    : 'https://www.migufun.com/middlepc/gamedetail/401157954?appChannel=40257763344';
  const reservationUrl = 'https://survey.zijieapi.com/q/v2/7653899716611457064/i3H2347g/04d0/#/';
  const steamWishlistUrl =
    'https://store.steampowered.com/app/3282300/Mistfall_Hunter/?utm_source=official_website&utm_medium=official_website&utm_campaign=official_website&utm_id=official_website&utm_term=official_website&utm_content=official_website';
  const officialDownloadUrl =
    'https://gcache.migu.cn/prod/upload/game_resource/small_screen_file/202608/1715/15/media-file-7e9a95f36bf243d7b640a25060fe5077/Migu-MistfallHunterLauncher-setup-20.0.0.8-40257763344.exe?timestamp=1881645379104&sid=10020&encrypt=e89ce8faf20f6e72dc3eeff3b97df6b2';

  const steamTitle = document.querySelector('.wishlist-title[data-type="steam"]');
  const steamLink = document.querySelector<HTMLAnchorElement>('.wishlist-btn-window');
  const pcTitle = document.querySelector('.wishlist-title[data-type="pc"]');
  const pcLink = document.querySelector('.wishlist-btn-pc')?.closest('a') as HTMLAnchorElement | null;
  const pcName = pcLink?.querySelector('.wishlist-name');
  const wishlistEl = document.querySelector('.wishlist');
  const purchaseLink = document.querySelector<HTMLAnchorElement>(
    '.wishlist-launched-actions [data-event="OfficialPurchase"]',
  );
  const downloadLink = document.querySelector<HTMLAnchorElement>(
    '.wishlist-launched-actions [data-event="OfficialDownload"]',
  );

  if (pcLink) {
    pcLink.setAttribute('data-event', isMobile ? 'PCDownload' : 'WishlistPC');
  }
  if (purchaseLink) {
    purchaseLink.style.display = '';
  }
  if (downloadLink) {
    downloadLink.style.display = '';
    downloadLink.style.marginTop = '';
  }

  wishlistEl?.classList.toggle('is-launched', phase === 'launched');
  console.log(phase);
  switch (phase) {
    case 'prepurchase':
      if (pcTitle) pcTitle.textContent = '抢先预购';
      if (pcName) pcName.textContent = '官方客户端';
      if (pcLink) pcLink.href = prePurchaseUrl;
      break;

    case 'launched':
      if (steamTitle) steamTitle.textContent = '';
      if (steamLink) steamLink.removeAttribute('href');
      if (pcTitle) pcTitle.textContent = '官方客户端';
      if (pcName) pcName.textContent = '购买&下载\n官方客户端';
      if (pcLink) {
        pcLink.setAttribute('data-event', 'OfficialDownload');
        pcLink.href = officialDownloadUrl;
      }
      if (purchaseLink) {
        purchaseLink.removeAttribute('href');
        purchaseLink.style.display = 'none';
      }
      if (downloadLink) {
        downloadLink.href = officialDownloadUrl;
        downloadLink.style.display = 'none';
        downloadLink.style.marginTop = '0';
      }
      break;

    case 'before_prepurchase':
    default:
      if (pcTitle) pcTitle.textContent = '预约游戏';
      if (pcName) pcName.textContent = 'PC 端';
      if (pcLink) pcLink.href = reservationUrl;
      break;
  }

  if (wishlistEl) {
    wishlistEl.style.display = 'flex';
  }
};
